/**
 * WordPress dependencies
 */
import { store, getContext } from '@wordpress/interactivity';

// Store the ESC key handler reference outside the store
let menuKeyHandler = null;
let isMenuOpen = false;

// Define the ESC key functions outside the store
const handleMenuKeyListener = (context) => {
	const menuButton = document.querySelector('.menu-button');

	// get the last focusable element in the element of .pattern-content
	const patternContent = document.querySelector('.pattern-content');
	// get the last a or button element in the pattern content	
	let lastFocusableElement = null;
	if (patternContent) {
		const focusableElements = patternContent.querySelectorAll('a, button');
		if (focusableElements.length > 0) {
			lastFocusableElement = focusableElements[focusableElements.length - 1];
		}
	}

	const handleMenuKey = (event) => {
		if (event.key === 'Escape') {
			context.isOpen = false;
			document.documentElement.classList.remove('noScroll');
			
			document.querySelector('.menu-button').focus();
		}

		// Trap focus: when tabbing forward from last element, loop back to menu button
		if (event.key === 'Tab' && !event.shiftKey && event.target == lastFocusableElement) {
			event.preventDefault();
			menuButton.focus();
		}
	};
	
	// Store the handler reference so we can remove it later
	menuKeyHandler = handleMenuKey;
	document.addEventListener('keydown', handleMenuKey);
};

const removeMenuKeyHandler = () => {
	if (menuKeyHandler) {
		document.removeEventListener('keydown', menuKeyHandler);
		menuKeyHandler = null;
	}
};



const { state } = store( 'create-block', {
	state: {
		get themeText() {
			return state.isDark ? state.darkText : state.lightText;
		},
	},
	actions: {
		toggleOpen() {
			const context = getContext();
			context.isOpen = ! context.isOpen;
			isMenuOpen = context.isOpen;
			
			// Add/remove noScroll class to HTML element
			if (context.isOpen) {
				document.documentElement.classList.add('noScroll');
				// Add ESC key listener when menu opens
				handleMenuKeyListener(context);
			} else {
				document.documentElement.classList.remove('noScroll');
				// Remove ESC key listener when menu closes
				removeMenuKeyHandler();
			}
		},
	},
	callbacks: {
		logIsOpen: () => {
			const { isOpen } = getContext();
			// Log the value of `isOpen` each time it changes.
			console.log( `Is open: ${ isOpen }` );
		},
	},
} );
